"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_redux_1 = require("react-redux");
var CheckboxHeaderComponent_1 = __importDefault(require("./CheckboxHeaderComponent"));
var index_1 = require("../../../actions/index");
var mapStateToHeaderProps = function (state, _a) {
    var grid = _a.grid, idx = _a.idx;
    return ({
        allValues: (state.grid[grid] && state.grid[grid].data) ? JSON.stringify(state.grid[grid].data.map(function (value) { return value[idx]; })) : '',
        checked: (state.grid[grid] && state.grid[grid].data && state.grid[grid].data.length > 0 && state.grid[grid].data.length === state.grid[grid].selection.length) === true
    });
};
var mapDispatchToHeaderProps = function (dispatch, _a) {
    var grid = _a.grid;
    return ({
        onChange: function (evt) { return dispatch((0, index_1.changeSelection)(grid, evt.target)); }
    });
};
var CheckboxHeaderContainer = (0, react_redux_1.connect)(mapStateToHeaderProps, mapDispatchToHeaderProps)(CheckboxHeaderComponent_1["default"]);
exports["default"] = CheckboxHeaderContainer;
